var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.classes},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,class:_vm.classes,domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }